import { useCallback, useRef } from "react";
import { useDispatch } from "react-redux";
import { setChatVisible } from "@/redux/reducers/chat";
import {
  CHAT_TYPES,
  MICROMODAL_PROACTIVE_CHAT_CONFIG,
} from "@/js/constants/chat";
import MicroModal from "micromodal";

import { useIdleTrigger } from "./useIdleTrigger";
import { useAddressInputTrigger } from "./useAddressInputTrigger";
import { useCustomEventTrigger } from "./useCustomEventTrigger";
import { useReturnToTopTrigger } from "./useReturnToTopTrigger";

export const useChatTriggers = (chatConfig) => {
  const { chatType } = chatConfig;
  const lastTriggerFired = useRef(null);
  const dispatch = useDispatch();

  // Memoize callback to prevent re-running
  const triggerChat = useCallback(
    (triggerName) => {
      if (
        chatType === CHAT_TYPES.PROACTIVE_V2 &&
        lastTriggerFired.current === null
      ) {
        MicroModal.show(
          "modal-proactive-chat",
          MICROMODAL_PROACTIVE_CHAT_CONFIG,
        );
      }
      lastTriggerFired.current = triggerName;
      dispatch(setChatVisible(true));
    },
    [dispatch, chatType],
  );

  // The triggers ✨

  useIdleTrigger({
    enabled: chatConfig?.triggers?.idle !== undefined,
    timeout: chatConfig?.triggers?.idle?.timeout,
    triggerChat,
  });

  useAddressInputTrigger({
    enabled: chatConfig?.triggers?.addressEntry !== undefined,
    timeout: chatConfig?.triggers?.addressEntry?.timeout,
    triggerChat,
  });

  useCustomEventTrigger({
    enabled: chatConfig?.triggers?.faqs !== undefined,
    timeout: chatConfig?.triggers?.faqs?.timeout,
    triggerChat,
    eventName: "faq-clicked",
    triggerSource: "FAQs",
  });

  useReturnToTopTrigger({
    enabled: chatConfig?.triggers?.returnedToTop !== undefined,
    timeout: chatConfig?.triggers?.returnedToTop?.timeout,
    triggerChat,
  });

  return lastTriggerFired;
};
